import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
declare let require: any;
const exifReader = require('exifreader');
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import sweetalert2 from 'sweetalert2';
import { InspectionService } from '../../../shared/services/inspection.service';
import { ExifToolService } from '../../../shared/services/exif-tool.service';
import { BrowserExiftoolService, ExifItem } from '../../../shared/services/browser-exiftool.service';
import { ExiftoolApiService } from '../../../shared/services/exiftool-api.service';
import { WasiExiftoolService, ParsedOutput } from '../../../shared/services/wasi-exiftool.service';
import { GoogleMap } from '@angular/google-maps';
import { CustomTitleService } from '../../../shared/services/custom-title.service';
const DEFAULT_ZOOM = 15;

@Component({
  selector: 'app-inspection-more-information',
  templateUrl: './inspection-more-information.component.html',
  styleUrls: ['./inspection-more-information.component.scss'],
})
export class InspectionMoreInformationComponent implements OnInit {

  inspectionId: string;
  inspection;
  pictureName;
  picture;
  ocrData;
  certificationData;
  enabledLens = false;
  lensHeight = null;
  lensWidth = null;
  circularLens = null;
  showTabOne = true;
  exifImage;
  bounds: any = false;
  indexPic;
  pictureAmount;
  manipulationIndicators = [];
  hasManipulationSigns = false;
  softwareEditedKeywords = [
    'photoshop',
    'lightroom',
    'gimp',
    'illustrator',
    'affinity',
    'capture one',
    'luminar',
    'ai',
    'intelligence',
    'neural',
    'edit',
    'edited',
  ];

  // Control de pestañas EXIF
  currentTab = 'basic';  // 'basic', 'advanced'
  hasGpsData = false;
  hasExposureData = false;
  hasFocalLengthData = false;

  // Datos EXIF avanzados
  advancedExifData: any = null;
  isLoadingAdvancedExif = false;
  advancedExifError = null;
  advancedAnalysisIndicators = [];
  hasAdvancedAnalysisResults = false;

  // Nuevos datos de ExifTool
  exifToolMetadata: ExifItem[] = [];

  // Datos completos de ExifTool WASI
  fullExifToolMetadata: ParsedOutput[] = [];
  groupedFullMetadata: Record<string, ParsedOutput[]> = {};
  isLoadingFullExif = false;
  fullExifError = null;
  isAIGenerated = false;
  aiIndicators: string[] = [];

  // Utilidad para iterar sobre claves de objetos en el template
  objectKeys = Object.keys;

  // Math global para usar en template
  Math = Math;

  markerOptions: google.maps.MarkerOptions = { draggable: false };
  mapOptions: google.maps.MapOptions = {};

  @ViewChild('googleMapRef')
    googleMaps: GoogleMap;
  zoom = DEFAULT_ZOOM - 1; // Hack to map zoom works fine
  private imgPosition: number = 0;
  showBoundingBoxes: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private inspectionService: InspectionService,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private router: Router,
    private exifToolService: ExifToolService,
    private browserExiftool: BrowserExiftoolService,
    private exiftoolApi: ExiftoolApiService,
    private wasiExiftool: WasiExiftoolService,
    private customTitleService: CustomTitleService,
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.activatedRoute.params.subscribe(async (params) => {
      this.inspectionId = params.id;
      this.pictureName = params.picName;
      await this.getInspectionData();
    });
  }

  async getInspectionData(): Promise<void> {
    this.inspectionService.getInspection(this.inspectionId).subscribe((inspection) => {
      this.inspection = inspection;
      this.pictureAmount = this.inspection.pictures.length;
      let picturesFiltered;
      if (this.inspection) {
        picturesFiltered = this.inspection.pictures.filter((value, index) => {
          if (value.name === this.pictureName) {
            this.indexPic = index;
          }
          return value.name === this.pictureName;
        });

        // Set title and breadcrumbs using CustomTitleService
        const titleIdentifier = this.inspection.vehicleType !== 'bike'
          ? this.inspection.licencePlate
          : this.inspection.numeroDoc;

        this.customTitleService.setTitleWithBreadcrumbs({
          title: `Detalle de Imagen - ${titleIdentifier}`,
          breadcrumbs: [
            { text: 'Inspecciones', route: ['/inspectionsList'] },
            { text: titleIdentifier, route: ['/inspections', this.inspectionId] },
            { text: this.pictureName },
          ],
        });
      }
      this.picture = picturesFiltered[0];
      this.loadMap();
      this.picture.latitude = Number(this.picture.latitude);
      this.picture.longitude = Number(this.picture.longitude);
      this.http.get(`${this.picture.link}?origin=example.com`, {
        responseType: 'blob',
      }).subscribe(async (imageBlob) => {
        // Determinar el tipo de archivo basado en el encabezado del blob
        const fileType = imageBlob.type || this.getMimeTypeFromUrl(this.picture.link);

        // Usar el nombre original de la imagen
        const originalFilename = this.getFilenameFromUrl(this.picture.link) ||
                                this.getOriginalFilename(this.picture.name);

        const imageFile = new File([imageBlob], originalFilename, {
          type: fileType,
          lastModified: Date.now(),
        });

        // Cargar datos básicos con exifReader
        try {
          const tags = await exifReader.load(imageFile);
          this.exifImage = tags;
          this.checkForManipulationSigns();
        } catch (error) {
          console.warn('Error al cargar datos básicos EXIF:', error);
        }

        // Cargar análisis avanzado de EXIF utilizando nuestro servicio
        this.loadAdvancedExifData(imageFile);

        // Cargar datos usando los nuevos servicios de ExifTool
        this.loadExifToolData(imageFile);

        // Cargar datos completos usando WASI ExifTool
        this.loadFullExifToolData(imageFile);
      });
      if (this.inspection.imageRecognitionData &&
        this.inspection.imageRecognitionData.ocrData &&
        this.inspection.imageRecognitionData.ocrData.length > 0) {
        const ocrDataFiltered =
          this.inspection.imageRecognitionData.ocrData.filter((value) => {
            return value.pictureName === this.pictureName;
          });
        this.ocrData = ocrDataFiltered[0];
      }
      if (this.inspection.certificationData && this.inspection.certificationData.length > 0) {
        const certificationDataFiltered = this.inspection.certificationData
          .filter((value) => {
            return value.pictureName === this.pictureName;
          });
        this.certificationData = certificationDataFiltered[0];
      }
    });
  }

  loadMap(): void {
    this.bounds = new window['google'].maps.LatLngBounds();
    this.bounds.extend(
      new window['google'].maps
        .LatLng(this.picture.location.coordinates[1], this.picture.location.coordinates[0]));

    setTimeout(() => {
      this.googleMaps.fitBounds(this.bounds, 0);
      const idleSubscription = this.googleMaps.idle.subscribe(() => {
        if (this.googleMaps.getZoom() > DEFAULT_ZOOM) {
          this.zoom = DEFAULT_ZOOM;
        }
        idleSubscription.unsubscribe();
      });
    }, 100);
  }

  copyToClipboard(val: string): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success(
      'Texto copiado al portapapeles',
      'Copiado',
      {
        positionClass: 'toast-bottom-right',
      });
  }
  zoomMode = 'hover-freeze';
  magnification;
  showPreventClick = true;
  enableLends() {
    this.showPreventClick =  !this.showPreventClick ;
    setTimeout(() => {
      const imageElement = document.querySelector('.img-itemphoto img') as HTMLElement;
      if (imageElement) {
        // Obtiene las dimensiones y posición de la imagen
        const rect = imageElement.getBoundingClientRect();
        
        // Calcula el centro de la imagen
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
  
        // Crea el evento de click con las coordenadas del centro
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
          clientX: centerX,
          clientY: centerY,
        });
  
        // Dispara el evento
        imageElement.dispatchEvent(clickEvent);
      }
    }, 0);
    // this.zoomMode =  this.enabledLens ? 'hover-freeze' : 'toggle'
    console.log('this.showPreventClick :>> ', this.showPreventClick);
    if (this.showPreventClick) {
      setTimeout(() => {
        const lensElement = document.querySelector('.ngxImageZoomLensEnabled') as HTMLElement;
        if (lensElement) {
          lensElement.style.opacity = '0';  // Establece la opacidad a 0

        }
      }, 0);
    } else {
      setTimeout(() => {
        const lensElement = document.querySelector('.ngxImageZoomLensEnabled') as HTMLElement;
        if (lensElement) {
          lensElement.style.opacity = '1';  // Establece la opacidad a 0
          this.showPreventClick = false;
        }
      }, 0);
    }
    this.showPreventClick = true;
    this.enabledLens =  true;
    this.magnification = this.enabledLens ? 1 : 0.9;
    this.lensHeight = this.enabledLens ? 200 : 0;
    this.lensWidth = this.enabledLens ? 200 : 0;
    this.circularLens = this.enabledLens ? true : false;
    this.showBoundingBoxes = false; 
    

    const existingContainers = document.getElementsByClassName('boundingBox-container');
    while (existingContainers.length > 0) {
      existingContainers[0].remove();
    }


  }

  changeTab(tab: string): void {
    if (tab === 'tab 1') {
      this.showTabOne = true;
    } else {
      this.showTabOne = false;
    }
    // Configurar la pestaña actual para EXIF
    if (!this.showTabOne) {
      this.currentTab = 'basic'; // Por defecto muestra la pestaña avanzada que contiene C2PA
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyEventDown(event: KeyboardEvent): void {
    if (event.key === 'ArrowLeft') {
      this.goToPreviousPicInfo();
    }
    if (event.key === 'ArrowRight') {
      this.goToNextPicInfo();
    }
  }

  goToNextPicInfo(): void {
    this.showBoundingBoxes = false;
    this.insertBoundingBoxes();
    this.rotate(0);
    const index = this.indexPic;
    let newIndex;
    if (index === (this.pictureAmount - 1)) {
      newIndex = 0;
    } else {
      newIndex = index + 1;
    }
    const selectedPicture = this.inspection.pictures[newIndex];
    const nextPictureUrl = `/inspections/${this.inspection.id}/pictures/${selectedPicture.name}`;
    this.router.navigateByUrl(nextPictureUrl)
      .catch(() => {
        sweetalert2.fire({
          title: 'Ups! Algo salio mal',
          text: 'Ocurrió un error al acceder a los datos.',
          type: 'error',
          confirmButtonText: 'Salir',
          buttonsStyling: false,
        });
      });
  }

  goToPreviousPicInfo(): void {
    this.showBoundingBoxes = false;
    this.insertBoundingBoxes();
    this.rotate(0);
    const index = this.indexPic;
    let newIndex;
    if (index === 0) {
      newIndex = (this.pictureAmount - 1);
    } else {
      newIndex = index - 1;
    }
    const selectedPicture = this.inspection.pictures[newIndex];
    const previousPictureUrl =
      `/inspections/${this.inspection.id}/pictures/${selectedPicture.name}`;
    this.router.navigateByUrl(previousPictureUrl)
      .catch(() => {
        sweetalert2.fire({
          title: 'Ups! Algo salio mal',
          text: 'Ocurrió un error al acceder a los datos.',
          type: 'error',
          confirmButtonText: 'Salir',
          buttonsStyling: false,
        });
      });
  }

  rotate(reset?) {
    const x: any = document.body.querySelector('.ngxImageZoomContainer');
    const img: any = document.body.querySelector('.ngxImageZoomThumbnail');
    const zoomContainer: any = document.body.querySelector('.zoom-container');
    const libZoom: any = document.body.querySelector('lib-ngx-image-zoom');

    if (reset === 0) {
      this.imgPosition = 0;
    } else {
      this.imgPosition = this.imgPosition + 90;
    }
    const isVerticalImage = img.height > img.width;

    const rotationValue = this.imgPosition % 360;
    x.style.transform = `rotate(${rotationValue}deg)`;
   
    if (this.inspection.sourceApp === 'native-app') {
      if (rotationValue === 0 || rotationValue === 180) {
        zoomContainer.style.height = `${img.height}px`;
      } else {
        zoomContainer.style.height = `${img.width}px`;
      }
    } else {
      if ((rotationValue === 90 || rotationValue === 270) && !isVerticalImage) {
        libZoom.style.height = `${img.width}px`;
        libZoom.style.display = 'grid';
      } else {
        libZoom.style.display = 'unset';
      }
    }

  }

  checkForManipulationSigns(): void {
    this.manipulationIndicators = [];

    // Revisar si faltan metadatos críticos que normalmente están presentes en fotos sin editar
    if (!this.exifImage.Make || !this.exifImage.Model) {
      this.manipulationIndicators.push('Falta información del dispositivo (Make/Model)');
    }

    // Verificar software utilizado para edición
    if (this.exifImage.Software) {
      const softwareName = this.exifImage.Software.description.toLowerCase();
      const editSoftwareFound = this.softwareEditedKeywords.some(keyword => softwareName.includes(keyword));
      if (editSoftwareFound) {
        this.manipulationIndicators.push(`Imagen procesada con software: ${this.exifImage.Software.description}`);
      }
    }

    // Verificar si hay datos de edición
    if (this.exifImage.PhotoshopSettings || this.exifImage.Photoshop) {
      this.manipulationIndicators.push('Datos de Photoshop detectados');
    }

    // Verificar datos XMP que pueden indicar edición
    const xmpKeys = Object.keys(this.exifImage).filter(key => key.includes('xmp') || key.includes('XMP'));
    if (xmpKeys.length > 0) {
      this.manipulationIndicators.push('Datos XMP presentes (posible edición)');
    }

    // Verificar historial de edición
    if (this.exifImage.History || (this.exifImage.MakerNote && this.exifImage.MakerNote.description.includes('edit'))) {
      this.manipulationIndicators.push('Historial de edición detectado');
    }

    // Verificar incongruencias entre fecha de creación y modificación
    if (this.exifImage.CreateDate && this.exifImage.ModifyDate) {
      const createDate = new Date(this.exifImage.CreateDate.description);
      const modifyDate = new Date(this.exifImage.ModifyDate.description);
      const timeDiff = Math.abs(modifyDate.getTime() - createDate.getTime()) / (1000 * 60);
      if (timeDiff > 5) { // Si hay más de 5 minutos de diferencia
        this.manipulationIndicators.push(`Tiempo entre creación y modificación: ${Math.round(timeDiff)} minutos`);
      }
    }

    this.hasManipulationSigns = this.manipulationIndicators.length > 0;
  }

  /**
   * Carga el análisis avanzado de metadatos usando ExifTool
   */
  async loadAdvancedExifData(imageFile: File): Promise<void> {
    this.isLoadingAdvancedExif = true;
    this.advancedExifError = null;

    try {
      this.advancedExifData = await this.exifToolService.extractMetadata(imageFile);

      if (this.advancedExifData && !this.advancedExifData.error) {
        // Si la pestaña actual es básica, cambiar a avanzada automáticamente
        if (this.currentTab === 'basic') {
          this.currentTab = 'advanced';
        }

        // Extraer indicadores si existe análisis de manipulación
        if (this.advancedExifData.manipulationAnalysis &&
            this.advancedExifData.manipulationAnalysis.hasManipulationSigns) {
          // Añadir solo indicadores que no estén ya en la lista básica
          for (const indicator of this.advancedExifData.manipulationAnalysis.indicators) {
            if (!this.manipulationIndicators.includes(indicator)) {
              this.manipulationIndicators.push(indicator);
            }
          }
          this.hasManipulationSigns = this.manipulationIndicators.length > 0;
        }
      } else if (this.advancedExifData && this.advancedExifData.error) {
        this.advancedExifError = this.advancedExifData.error;
        console.error('Error en ExifTool:', this.advancedExifData.details || 'Detalles no disponibles');
      }
    } catch (error) {
      console.error('Error al cargar datos EXIF avanzados:', error);
      this.advancedExifError = 'Error al procesar metadatos avanzados';
    } finally {
      this.isLoadingAdvancedExif = false;
    }
  }

  /**
   * Carga datos de ExifTool usando los nuevos servicios
   */
  private loadExifToolData(file: File): void {
    this.isLoadingAdvancedExif = true;

    // Intentar extraer datos con el servicio de ExifTool API
    this.exiftoolApi.extractMetadata(file).subscribe(
      result => {
        this.isLoadingAdvancedExif = false;

        if (result.error) {
          this.advancedExifError = result.error;
          console.error('Error en ExifTool API:', result.error);
          return;
        }

        // Guardar los metadatos
        this.exifToolMetadata = result.metadata;

        console.log('***********************')
        console.log(this.exifToolMetadata)
        // Actualizar el análisis de manipulación
        if (result.hasManipulationSigns) {
          // Añadir nuevos indicadores sin duplicados
          for (const indicator of result.manipulationIndicators) {
            if (!this.manipulationIndicators.includes(indicator)) {
              this.manipulationIndicators.push(indicator);
            }
          }
          this.hasManipulationSigns = this.manipulationIndicators.length > 0;
        }

        // Cambiar a la pestaña avanzada
        if (this.currentTab === 'basic' && this.exifToolMetadata.length > 0) {
          this.currentTab = 'advanced';
        }

        // Inicializar propiedades de pestañas EXIF
        this.hasGpsData = !!(this.exifImage?.GPSLatitude || this.exifImage?.GPSLongitude);
        this.hasExposureData = !!this.exifImage?.ExposureTime;
        this.hasFocalLengthData = !!this.exifImage?.FocalLength;
      },
      error => {
        this.isLoadingAdvancedExif = false;
        this.advancedExifError = 'Error al procesar metadatos con ExifTool';
        console.error('Error al cargar datos de ExifTool:', error);

        // Como respaldo, intentar con el servicio local
        this.browserExiftool.extractMetadata(file)
          .then(result => {
            if (!result.error) {
              this.exifToolMetadata = result.metadata;

              // Actualizar el análisis de manipulación
              if (result.hasManipulationSigns) {
                for (const indicator of result.manipulationIndicators) {
                  if (!this.manipulationIndicators.includes(indicator)) {
                    this.manipulationIndicators.push(indicator);
                  }
                }
                this.hasManipulationSigns = this.manipulationIndicators.length > 0;
              }

              this.advancedExifError = null; // Limpiar error si el respaldo funciona
            }
          })
          .catch(err => console.error('Error también en el servicio local:', err));
      },
    );
  }

  /**
   * Carga datos completos de ExifTool usando WASI
   */
  loadFullExifToolData(file: File): void {
    this.isLoadingFullExif = true;
    this.fullExifError = null;

    this.wasiExiftool.extractFullMetadata(file)
      .then(metadata => {
        console.log('Metadatos completos cargados:', metadata.length, 'elementos');
        this.fullExifToolMetadata = metadata;

        // Asegurarse de que exifToolMetadata también se actualiza
        // Este es el array que se usa en la interfaz, y debe sincronizarse
        const simplifiedMetadata = metadata.map(item => ({
          label: item.label,
          value: item.value,
        }));
        this.exifToolMetadata = simplifiedMetadata;

        // Agrupar metadatos por categoría
        this.groupedFullMetadata = this.getGroupedExifTags();

        // Verificar si hay datos de manipulación o IA
        this.checkForManipulationSigns();

        this.isLoadingFullExif = false;
      })
      .catch(error => {
        console.error('Error al cargar metadatos completos:', error);
        this.fullExifError = error.message || 'Error desconocido al cargar metadatos.';
        this.isLoadingFullExif = false;
      });
  }

  /**
   * Establece la pestaña activa
   * @param tab Nombre de la pestaña a activar
   */
  setCurrentTab(tab: string): void {
    this.currentTab = tab;
  }

  /**
   * Busca un valor de metadato por etiqueta
   */
  getMetadataValue(label: string): string {
    const item = this.exifToolMetadata.find(m => m.label === label);
    return item ? item.value : null;
  }

  /**
   * Obtiene las etiquetas EXIF agrupadas por categoría
   */
  getGroupedExifTags(): { [category: string]: ExifItem[] } {
    const groups: { [category: string]: ExifItem[] } = {
      'Camera': [],
      'Image': [],
      'GPS': [],
      'Software': [],
      'Date/Time': [],
      'C2PA': [],
      'Other': [],
    };

    // Distribuir los metadatos en categorías
    for (const item of this.exifToolMetadata) {
      // Aplicar normalización a etiquetas y valores
      const normalizedItem = {
        label: this.normalizeEncoding(item.label),
        value: this.normalizeEncoding(item.value?.toString() || ''),
      };

      const label = normalizedItem.label.toLowerCase();
      const value = normalizedItem.value;

      // Filtrar mensajes de depuración y etiquetas no deseadas
      if (
        label.includes('advertencia') ||
        label.includes('warning') ||
        label.includes('no encontrado') ||
        label.includes('not found') ||
        label.includes('tag disponible') ||
        label.includes('tag available') ||
        label.includes('total de tags') ||
        label.includes('total tags') ||
        label.includes('debug') ||
        label === 'tag' ||
        value.includes('SCALAR(') ||
        value.startsWith('No encontrado') ||
        value.startsWith('ADVERTENCIA') ||
        value.startsWith('Tag disponible')
      ) {
        continue; // Saltar este elemento
      }

      // Asignar a categorías
      if (label.includes('c2pa') ||
        label.includes('claim') ||
        label.includes('actions') ||
        label.includes('digital') ||
        label.includes('source') ||
        label.includes('c2padetected')) {
        groups['C2PA'].push(item);
      } else if (label.includes('gps') || label.includes('latitude') || label.includes('longitude')) {
        groups['GPS'].push(item);
      } else if (label.includes('camera') || label.includes('make') || label.includes('model') ||
        label.includes('exposure') || label.includes('iso') || label.includes('focal') ||
        label.includes('aperture') || label.includes('flash')) {
        groups['Camera'].push(item);
      } else if (label.includes('software') || label.includes('photoshop') || label.includes('edit')) {
        groups['Software'].push(item);
      } else if (label.includes('date') || label.includes('time') || label.includes('created') ||
        label.includes('modified')) {
        groups['Date/Time'].push(item);
      } else if (label.includes('width') || label.includes('height') || label.includes('resolution') ||
        label.includes('color') || label.includes('orientation')) {
        groups['Image'].push(item);
      } else {
        groups['Other'].push(item);
      }
    }

    // Eliminar grupos vacíos
    for (const key of Object.keys(groups)) {
      if (groups[key].length === 0) {
        delete groups[key];
      }
    }

    return groups;
  }

  /**
   * Verifica si una propiedad es sospechosa (indicadora de manipulación)
   */
  isSuspiciousProperty(label: string, value: string): boolean {
    // Software de edición conocido
    if (label === 'Software' || label === 'ProcessingSoftware') {
      const editingSoftware = [
        'photoshop', 'lightroom', 'gimp', 'affinity', 'capture one',
        'luminar', 'pixlr', 'paintshop', 'acdsee', 'photolab',
      ];

      return editingSoftware.some(software =>
        value.toLowerCase().includes(software)
      );
    }

    // Propiedades que contienen palabras sospechosas
    const suspiciousKeywords = ['edit', 'modified', 'photoshop', 'ai', 'neural', 'generator', 'processed'];

    const propNameContainsSuspicious = suspiciousKeywords.some(keyword =>
      label.toLowerCase().includes(keyword.toLowerCase())
    );

    const valueContainsSuspicious = value && typeof value === 'string' && suspiciousKeywords.some(keyword =>
      value.toLowerCase().includes(keyword.toLowerCase())
    );

    // Valores sospechosos específicos
    const specificSuspicious = (
      (label === 'ModifyDate' && value !== this.getMetadataValue('CreateDate')) ||
      (label.includes('Edited') && value.toLowerCase() !== 'no') ||
      (label.includes('Modified') && !label.includes('Unmodified'))
    );

    return propNameContainsSuspicious || valueContainsSuspicious || specificSuspicious;
  }

  /**
   * Formatea una fecha ISO a formato local amigable
   */
  formatDate(isoDate: string): string {
    if (!isoDate) return null;

    try {
      const date = new Date(isoDate);
      if (isNaN(date.getTime())) {
        return null;
      }

      return date.toLocaleString();
    } catch (error) {
      return null;
    }
  }

  /**
   * Busca un valor de metadato completo por etiqueta
   */
  getFullMetadataValue(label: string): string {
    const item = this.fullExifToolMetadata.find(m => m.label === label);
    return item ? item.value : null;
  }

  /**
   * Busca un valor en los metadatos agrupados
   */
  findInGroupedMetadata(category: string, label: string): ParsedOutput | null {
    if (!this.groupedFullMetadata || !this.groupedFullMetadata[category]) {
      return null;
    }

    return this.groupedFullMetadata[category].find(item =>
      item.label === label
    ) || null;
  }

  /**
   * Verifica si la imagen fue generada por IA según los metadatos
   */
  hasAiGeneratedData(): boolean {
    if (!this.exifToolMetadata) return false;

    // Buscar el tag específico que indica generación por IA
    return this.exifToolMetadata.some(item =>
      item.label === 'ImagenGeneradaPorIA' ||
      (item.label === 'ActionsDigitalSourceType' &&
       item.value.includes('trainedAlgorithmicMedia')),
    );
  }

  /**
   * Obtiene el nombre del software de IA utilizado
   */
  getAiSoftware(): string | null {
    if (!this.exifToolMetadata) return null;

    const softwareItem = this.exifToolMetadata.find(item =>
      item.label === 'SoftwareDeIA' ||
      item.label === 'ActionsSoftwareAgentName',
    );

    return softwareItem ? softwareItem.value : null;
  }

  /**
   * Verifica si hay datos de certificación C2PA
   */
  hasCertificationData(): boolean {
    if (!this.exifToolMetadata) {
      return false;
    }

    // Buscar etiquetas relacionadas con C2PA
    return this.exifToolMetadata.some(item =>
      item.label === 'C2PADetected' ||
      item.label.includes('C2PA') ||
      item.label.includes('Claim') ||
      item.label.includes('Action') ||
      item.label.includes('Validation') ||
      item.label.includes('Assertion') ||
      (item.value && item.value.includes('c2pa')) ||
      (item.value && item.value.includes('jumbf')),
    );
  }

  /**
   * Verifica si la validación C2PA es válida
   */
  isC2paValid(): boolean {
    if (!this.exifToolMetadata) return false;

    // Buscar elementos de validación específicos
    const validationItem = this.exifToolMetadata.find(item =>
      item.label === 'ValidationResultsActiveManifestSuccessCode' ||
      item.label.includes('ValidationResults'),
    );

    // Si encontramos información específica de validación, verificarla
    if (validationItem) {
      return validationItem.value.includes('validated') &&
             !validationItem.value.includes('failed');
    }

    // Si no hay información específica de validación, considerar válido si se detectó C2PA
    const c2paDetected = this.exifToolMetadata.find(item =>
      item.label === 'C2PADetected' ||
      item.label === 'c2padetected'
    );

    // Verificar si el valor es verdadero, considerando que puede venir como string o booleano
    if (c2paDetected) {
      const value = String(c2paDetected.value).toLowerCase();
      return value === 'true' || value === '1';
    }

    return false;
  }

  /**
   * Obtiene los detalles específicos de la certificación C2PA
   */
  getC2paDetails(): any[] {
    if (!this.exifToolMetadata) return [];

    // Filtrar tags relacionados con C2PA que son relevantes para mostrar
    return this.exifToolMetadata.filter(item =>
      (item.label.includes('C2PA') ||
       item.label.includes('Claim') ||
       item.label.includes('Validation') ||
       item.label.includes('Actions')) &&
      // Excluir campos con datos binarios o muy largos
      !item.label.includes('Data') &&
      !item.value.includes('SCALAR') &&
      !item.value.includes('ARRAY'),
    );
  }

  /**
   * Convierte datos de ExifTool en un formato para descarga
   */
  prepareMetadataForDownload(): string {
    if (!this.fullExifToolMetadata || this.fullExifToolMetadata.length === 0) {
      return JSON.stringify(this.exifToolMetadata, null, 2);
    }

    // Crear un objeto organizado por categorías
    const organizedData = {};

    Object.keys(this.groupedFullMetadata).forEach(category => {
      organizedData[category] = {};
      this.groupedFullMetadata[category].forEach(item => {
        organizedData[category][item.label] = item.value;
      });
    });

    return JSON.stringify(organizedData, null, 2);
  }

  /**
   * Descarga los metadatos como archivo JSON
   */
  downloadMetadata(): void {
    if (!this.picture) {
      this.toastr.error('No hay metadatos disponibles para descargar');
      return;
    }

    const data = this.prepareMetadataForDownload();
    const blob = new Blob([data], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${this.picture.description || 'image'}_metadata.json`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  /**
   * Obtiene el nombre original del archivo a partir del nombre de la foto
   */
  private getOriginalFilename(pictureName: string): string {
    // Si el nombre ya tiene extensión, usarlo directamente
    if (/\.(jpe?g|png|gif|webp|tiff?)$/i.test(pictureName)) {
      return pictureName;
    }

    // Si no tiene extensión, intentar inferirla o usar jpg como predeterminado
    return `${pictureName}.jpg`;
  }

  /**
   * Determina el tipo MIME basado en la extensión del archivo
   */
  private getMimeTypeFromFilename(filename: string): string {
    if (!filename) return 'image/jpeg';

    const ext = filename.toLowerCase().split('.').pop() || '';

    const mimeTypes = {
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'webp': 'image/webp',
      'tif': 'image/tiff',
      'tiff': 'image/tiff',
    };

    return mimeTypes[ext] || 'image/jpeg';
  }

  /**
   * Obtiene el nombre del archivo desde una URL
   */
  private getFilenameFromUrl(url: string): string | null {
    if (!url) return null;

    // Extraer el nombre del archivo de la URL
    const urlParts = url.split('/');
    let filename = urlParts[urlParts.length - 1];

    // Eliminar parámetros de consulta si existen
    if (filename.includes('?')) {
      filename = filename.split('?')[0];
    }

    return filename || null;
  }

  /**
   * Determina el tipo MIME basado en la URL de la imagen
   */
  private getMimeTypeFromUrl(url: string): string {
    if (!url) return 'image/jpeg';

    const filename = this.getFilenameFromUrl(url) || '';
    const ext = filename.toLowerCase().split('.').pop() || '';

    const mimeTypes = {
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'webp': 'image/webp',
      'tif': 'image/tiff',
      'tiff': 'image/tiff',
    };

    return mimeTypes[ext] || 'image/jpeg';
  }

  /**
   * Normaliza la codificación de texto para corregir problemas con caracteres especiales
   * @param text Texto a normalizar
   * @returns Texto normalizado con caracteres UTF-8 correctos
   */
  private normalizeEncoding(text: string): string {
    if (!text) return '';

    // Corregir problemas comunes de codificación
    return text
      .replace(/Ã³/g, 'ó')
      .replace(/Ã¡/g, 'á')
      .replace(/Ã©/g, 'é')
      .replace(/Ã­/g, 'í')
      .replace(/Ãº/g, 'ú')
      .replace(/Ã±/g, 'ñ')
      .replace(/Ã/g, 'í')
      .replace(/Â/g, '')
      .replace(/VersiÃ³n/g, 'Versión')
      .replace(/Ã¼/g, 'ü')
      .replace(/Ã\s/g, 'Ñ');
  }

  /**
   * Función de depuración para mostrar todos los metadatos en la consola
   */
  debugMetadata(): void {
    console.log('======= DEPURACIÓN DE METADATOS =======');
    console.log('fullExifToolMetadata:', this.fullExifToolMetadata);
    console.log('exifToolMetadata:', this.exifToolMetadata);
    console.log('groupedFullMetadata:', this.groupedFullMetadata);

    // Buscar específicamente datos relacionados con C2PA
    const c2paData = this.exifToolMetadata.filter(item =>
      item.label.includes('C2PA') ||
      item.label.includes('Claim') ||
      item.label.includes('Action') ||
      item.label.includes('Validation') ||
      item.label.includes('Assertion') ||
      (item.value && (item.value.includes('c2pa') || item.value.includes('jumbf'))),
    );

    console.log('Datos específicos C2PA encontrados:', c2paData);

    console.log('¿Tiene datos de certificación?', this.hasCertificationData());
    console.log('¿Es una imagen generada por IA?', this.hasAiGeneratedData());
    console.log('=========================================');
  }

  /**
   * Obtiene un resumen de insights detectados en la imagen
   * @returns Array de insights como cadenas de texto
   */
  getImageInsights(): string[] {
    const insights: string[] = [];

    // Verificar si faltan datos de cámara
    if (!this.exifImage?.Make || !this.exifImage?.Model) {
      insights.push('⚠️ Falta información de marca o modelo de cámara');
    }

    // Verificar si la imagen fue generada por IA
    if (this.hasAiGeneratedData()) {
      const aiSoftware = this.getAiSoftware();
      if (aiSoftware) {
        insights.push(`🤖 Imagen generada por IA (${aiSoftware})`);
      } else {
        insights.push('🤖 Imagen posiblemente generada por IA');
      }
    }

    // Agregar indicadores de manipulación detectados
    if (this.hasManipulationSigns && this.manipulationIndicators.length > 0) {
      insights.push(`⚠️ Posibles signos de manipulación detectados:`);
      // Agregar cada indicador de manipulación como un sub-insight con formato
      this.manipulationIndicators.forEach(indicator => {
        insights.push(`    • ${indicator}`);
      });
    }

    // Verificar formato y resolución
    if (this.exifImage?.ImageWidth && this.exifImage?.ImageHeight) {
      const w = this.exifImage.ImageWidth.value || this.exifImage.ImageWidth.description;
      const h = this.exifImage.ImageHeight.value || this.exifImage.ImageHeight.description;

      // Comprobar si es alta resolución
      const isHighRes = w * h > 2000000; // Más de 2 megapíxeles
      if (isHighRes) {
        insights.push(`📷 Imagen de alta resolución (${w}x${h})`);
      } else {
        insights.push(`📷 Imagen de baja resolución (${w}x${h})`);
      }

      // Comprobar si la relación de aspecto es estándar (16:9, 4:3, 3:2, etc.)
      const ratio = w / h;
      const isStandardRatio =
        Math.abs(ratio - 16 / 9) < 0.1 || // 16:9
        Math.abs(ratio - 4 / 3) < 0.1 ||  // 4:3
        Math.abs(ratio - 3 / 2) < 0.1 ||  // 3:2
        Math.abs(ratio - 1) < 0.1;      // 1:1

      if (!isStandardRatio) {
        insights.push(`📏 Proporción de imagen inusual (${w}x${h})`);
      }
    }

    // Verificar si falta información GPS
    const hasGPS = this.exifToolMetadata?.some(item =>
      item.label.toLowerCase().includes('gps') &&
      item.label.toLowerCase().includes('latitude')
    );

    if (!hasGPS) {
      insights.push('📍 Sin datos de geolocalización');
    }

    // Si no hay insights, agregar mensaje predeterminado
    if (insights.length === 0) {
      insights.push('✅ No se detectaron anomalías en la imagen');
    }

    return insights;
  }
  calculateImageRatio(): number {
    const originalImage = new Image();
    originalImage.src = this.picture.link;
    const container = document.querySelector('.ngxImageZoomContainer');
    const containerWidth = container ? container.clientWidth : 0;
    const widthRatio = containerWidth / originalImage.width;
    
    return widthRatio;
  }
  damageTypes = [
    { name: 'Vidrio Dañado', color: '#E74C3C', key: 'damagedGlass', show: true },
    { name: 'Abolladura', color: '#F1C40F', key: 'dent', show: true },
    { name: 'Pintura Dañada', color: '#9B59B6', key: 'damagedPaint', show: true  },
    { name:'Patente', color: '#34495E', key: 'licencePlate', show: true },
    { name: 'Rayón', color: '#E67E22', key: 'scratch', show: true  },
    { name: 'Luz Trasera', color: '#851222', key: 'brokenTailLight', show: true  },
  ];
  probabilityThreshold: number = 0.5;
  insertBoundingBoxes() {
    // console.log('acaaaaaa',this.calculateImageRatio())
    const ratio = this.calculateImageRatio();
    this.showPreventClick = true;
    setTimeout(() => {
      const lensElement = document.querySelector('.ngxImageZoomLensEnabled') as HTMLElement;
      if (lensElement) {
        lensElement.style.opacity = '0';  // Establece la opacidad a 0

      }
    }, 0);
    if (!this.showBoundingBoxes) {
      const existingContainers = document.getElementsByClassName('boundingBox-container');
      while (existingContainers.length > 0) {
        existingContainers[0].remove();
      }
      return;
    }

    const data = this.inspection.damageAnalysisResponse.results.filter((element)=>
      element.pictureName === this.pictureName,
    );

    const predictions = data[0].damageDetections;
    const imageContainer = document.getElementsByClassName('ngxImageZoomContainer')[0];
    const existingContainers = document.getElementsByClassName('boundingBox-container');
    while (existingContainers.length > 0) {
      existingContainers[0].remove();
    }
    const filteredPredictions = predictions
      .filter(p => {
      // Get confidence value from the new structure
        const confidence = p.confidence ? parseFloat(p.confidence) : 0;
      
        const basicFilter = confidence >= 1 - this.probabilityThreshold && 
                         !['car', 'frontLight', 'tailLight'].includes(p.damageType);
        const damageType = this.damageTypes.find(d => d.key === p.damageType);
        return basicFilter && damageType?.show;
      });

    filteredPredictions.forEach(prediction => {
      // Get coordinates from the new structure
      const coords = prediction.coordinates && prediction.coordinates.length > 0 ? prediction.coordinates[0] : null;
      if (!coords) return;
      
      const x = coords.x ? parseInt(coords.x) : 0;
      const y = coords.y ? parseInt(coords.y) : 0;
      const width = coords.width;
      const height = coords.height;
      
      // Find the damage type configuration
      const damageConfig = this.damageTypes.find(d => d.key === prediction.damageType);
      if (!damageConfig) return;

      // Convert from absolute pixels to relative values if needed
      const left = x ;
      const top = y;
      const boxWidth = width;
      const boxHeight = height;

      const container = document.createElement('div');
      container.setAttribute('class', 'boundingBox-container');
      container.setAttribute('style', 
        `position: absolute; 
         top: ${top * ratio}px; 
         left: ${left * ratio}px;`,
      );

      const boxDiv = document.createElement('div');
      boxDiv.setAttribute('class', 'boundingBox');
      boxDiv.setAttribute('style', 
        `width: ${boxWidth * ratio}px; 
         height: ${boxHeight * ratio}px; 
         border: 2px solid ${damageConfig.color};`,
      );

      const tagDiv = document.createElement('div');
      tagDiv.setAttribute('class', 'tag-label');
      tagDiv.setAttribute('style',
        `background-color: ${damageConfig.color};
         color: white;
         padding: 2px 6px;
         font-size: 12px;
         border-radius: 3px;
         margin-top: -2px;`,
      );
      tagDiv.textContent = damageConfig.name;
       console.log(tagDiv)
      container.appendChild(boxDiv);
      container.appendChild(tagDiv);
      imageContainer.prepend(container);
    });
  }
  onProbabilityChange(event: any) {
    this.probabilityThreshold = event.target.value;
    this.insertBoundingBoxes();
  }

  disableLens() {
    this.enabledLens = false;
    this.showBoundingBoxes = true;
    this.insertBoundingBoxes();
  }

  toggleDamage(damage: any) {
    damage.show = !damage.show;
    this.insertBoundingBoxes();
  }

  /**
   * Obtiene información identificativa del certificado C2PA
   * @returns Información del certificador y otros detalles de identificación
   */
  getCertificateInfo(): { issuer: string, id: string, date: string } {
    if (!this.exifToolMetadata) {
      return { issuer: 'Desconocido', id: 'N/A', date: 'N/A' };
    }
    // Buscar información del emisor del certificado
    const issuerItem = this.exifToolMetadata.find(item => 
      item.label.includes('Issuer') || 
      item.label.includes('Producer') ||
      item.label.includes('CreatorTool') ||
      item.label.includes('SoftwareAgent')
    );

    // Buscar un identificador del certificado
    const idItem = this.exifToolMetadata.find(item => 
      item.label.includes('ClaimID') || 
      item.label.includes('ManifestID') ||
      item.label.includes('AssertionID') ||
      item.label.includes('Hash')
    );

    // Buscar fecha de certificación
    const dateItem = this.exifToolMetadata.find(item => 
      item.label.includes('ClaimDate') || 
      item.label.includes('SigningTime') ||
      item.label.includes('AssertionTime') ||
      (item.label.includes('Date') && item.label.includes('C2PA'))
    );

    return {
      issuer: issuerItem ? issuerItem.value : '-',
      id: idItem ? (idItem.value.length > 20 ? idItem.value.substring(0, 20) + '...' : idItem.value) : '-',
      date: dateItem ? this.formatDate(dateItem.value) : '-'
    };
  }
}
